(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-feature-brand"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('.featured-carousel')) {
      var featuredSwiper = new Swiper('.featured-carousel', {
        slidesPerView: 2.2,
        spaceBetween: 64,
        breakpoints: {
          1024: {
            slidesPerView: 6,
            spaceBetween: 64,
          },
          768: {
            slidesPerView: 3.2,
            spaceBetween: 35,
          },
          575: {
            slidesPerView: 2.2,
            spaceBetween: 14,
          },
          375: {
            slidesPerView: 2.2,
            spaceBetween: 14,
          },
          0: {
            slidesPerView: 2.2,
            spaceBetween: 14,
          },
        },
        loop: true,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-feature-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var featureSwiper = new Swiper('.features-grid', {
      slidesPerView: 5,
      spaceBetween: 160,
      loop: true,
      autoplay: {
        delay: 3000, // 3 seconds auto-rotate
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        1366: {
          slidesPerView: 5,
          spaceBetween: 160,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 160,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
        575: {
          slidesPerView: 2,
          spaceBetween: 35,
        },
        375: {
          slidesPerView: 1,
          spaceBetween: 25,
        },
        0: {
          slidesPerView: 1,
          spaceBetween: 25,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var swiper = new Swiper('.product_grid__block', {
      slidesPerView: 2,
      spaceBetween: 42,
      centeredSlides: false,
      loop: false,
      breakpoints: {
        1280: {
          slidesPerView: 2,
          spaceBetween: 42,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 32,
        },
        990: {
          slidesPerView: 1.5,
          spaceBetween: 32,
          slidesOffsetAfter:0,
          slidesOffsetBefore:0,
        },
        768: {
          slidesPerView: 1.5,
          spaceBetween: 32,
          slidesOffsetAfter:20,
          slidesOffsetBefore:20,
        },
        575: {
          slidesPerView: 1.2,
          spaceBetween: 32,
          slidesOffsetAfter:20,
          slidesOffsetBefore:20,
        },
        414: {
          slidesPerView: 1.5,
          spaceBetween: 32,
          slidesOffsetAfter:20,
          slidesOffsetBefore:20,
        },
        0: {
          slidesPerView: 1.2,
          spaceBetween: 32,
          slidesOffsetAfter:20,
          slidesOffsetBefore:20,
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tab-image-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.tab-btn');
    const panes = document.querySelectorAll('.tab-pane');

    buttons.forEach((btn) => {
      btn.addEventListener('click', function () {
        const target = this.getAttribute('data-tab');

        // reset all
        buttons.forEach((b) => b.classList.remove('active'));
        panes.forEach((p) => p.classList.remove('active'));

        // activate
        this.classList.add('active');
        document.getElementById(target).classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery-poup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var artistSwiper = new Swiper('.artist-grid', {
      spaceBetween: 24,
      slidesPerView: 1.8, // default for smallest screens
      breakpoints: {
        375: {
          slidesPerView: 2.2,
          spaceBetween: 24,
        },
        414: {
          slidesPerView: 2.2,
          spaceBetween: 24,
        },
        575: {
          slidesPerView: 2.2,
          spaceBetween: 24,
        },
        768: {
          slidesPerView: 3.5,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 7,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 7,
          spaceBetween: 24,
        },
      },
    });
    // Pause videos when popup closes
    document.querySelectorAll('.video-popup-toggle').forEach((toggle) => {
      toggle.addEventListener('change', function () {
        if (!this.checked) {
          const popup = this.nextElementSibling;
          const video = popup.querySelector('video');
          const iframe = popup.querySelector('iframe');

          if (video) {
            video.pause();
            video.currentTime = 0; // reset to start
          }

          if (iframe) {
            // Reset src to stop playback (YouTube/Vimeo)
            const src = iframe.src;
            iframe.src = src;
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
